/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 二手车列表+get
// 接口地址 /api/v1/auctions/reviews
Mock.mock(/auctions\/reviews/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'total': 50,
    'comments|10': [{
      'id|+1': 1,
      'payment_speed': 2,
      'content': 'string',
      'transfer_speed': 3,
      'dealer_professional': 1,
      'images': [
        'https://test-images-cdn.cheanjia.com/auction_image/feedback/SDBEPTgX9C2cdC58gpPUFk.jpg',
        'https://test-images-cdn.cheanjia.com/auction_image/feedback/SDBEPTgX9C2cdC58gpPUFk.jpg'
      ]
    }]
  }
})
